import _ from 'underscore';
import { AudienceType } from './constants';

export class AudienceDao {
  constructor({
    loadAudiencesAsync, //= () => Promise.resolve(),
  } = {}) {
    this.loadAudiencesAsync = loadAudiencesAsync;
    this.audiencesById = {};
    this.audiencesByName = {};
    this.audiencesByTypeValue = {};
  }

  refresh = () => this.loadAudiencesData();

  loadAudiencesData = () => {
    const audienceTypes = _.map(_.values(AudienceType), x => x.mtEnum);

    return this.loadAudiencesAsync(audienceTypes)
      .then((audiences) => {
        const audienceTypeByMTEnum = _.object(_.map(AudienceType, type => [type.mtEnum, type]));

        // Here skips unknown audience types
        const audienceWithInternalType = _.compact(_.map(
          audiences,
          (audience) => {
            const internalAudienceType = audienceTypeByMTEnum[audience.Type];
            return internalAudienceType ?
              _.defaults({ Type: internalAudienceType }, audience) : null;
          }
        ));

        this.audiences = audienceWithInternalType;
        this.audiencesById = _.object(_.map(
          audienceWithInternalType,
          audience => [audience.Id, audience]
        ));
        this.audiencesByName = _.object(_.map(
          audienceWithInternalType,
          audience => [audience.Name, audience]
        ));
        this.audiencesByTypeValue = _.groupBy(
          audienceWithInternalType,
          audience => audience.Type.value
        );
      });
  };

  getAllAudiences = () => this.audiences;

  getAudienceByName = audienceName => this.audiencesByName[audienceName];

  getAudienceById = audienceId => this.audiencesById[audienceId];

  getAudiencesByType = type => this.audiencesByTypeValue[type.value];

  getAudiencesByTypeValue = typeValue => this.audiencesByTypeValue[typeValue];
}
